import { DatePicker } from "@mui/x-date-pickers";
import type { Dayjs } from "dayjs";
import { datePickerTextFieldStyles } from "../../utils/formStyles";

interface BrandedDatePickerProps {
  label?: string;
  value?: Dayjs | null;
  onChange?: (value: Dayjs | null) => void;
  error?: boolean;
  helperText?: string | null;
  fullWidth?: boolean;
  maxDate?: Dayjs;
}

export const BrandedDatePicker = ({
  error,
  helperText,
  fullWidth = true,
  ...props
}: BrandedDatePickerProps) => (
  <DatePicker
    format="DD/MM/YYYY"
    sx={{ mb: 2, width: fullWidth ? "100%" : "auto" }}
    slotProps={{
      textField: {
        variant: "standard",
        fullWidth,
        error,
        helperText,
        sx: datePickerTextFieldStyles,
      },
      actionBar: {
        actions: ["cancel", "accept"],
      },
      mobilePaper: {
        sx: {
          borderRadius: 3,
          "& .MuiTypography-root": {
            color: "#3f4e8c",
          },
          "& .MuiPickersCalendarHeader-label": {
            color: "#3f4e8c",
          },
          "& .MuiPickersCalendarHeader-root .MuiIconButton-root": {
            color: "#7479ae",
            "&:hover": {
              backgroundColor: "rgba(116, 121, 174, 0.1)",
            }
          },
          "& .MuiPickersDay-root": {
            color: "#3f4e8c",
          },
          "& .MuiPickersDay-root.Mui-selected": {
            backgroundColor: "#BFA2CA",
            color: "#3f4e8c",
          },
          "& .MuiPickersYear-root": {
            color: "#3f4e8c",
          },
          "& .MuiYearCalendar-button": {
            color: "#3f4e8c",
          },
          "& .MuiPickersMonth-root": {
            color: "#3f4e8c",
          },
          "& .MuiDialogActions-root .MuiButton-root": {
            color: "#7B8EDC",
          },
        },
      },
      desktopPaper: {
        sx: {
          "& .MuiTypography-root": {
            color: "#3f4e8c",
          },
          "& .MuiPickersCalendarHeader-label": {
            color: "#3f4e8c",
          },
          "& .MuiPickersCalendarHeader-root .MuiIconButton-root": {
            color: "#7479ae",
            "&:hover": {
              backgroundColor: "rgba(116, 121, 174, 0.1)",
            }
          },
          "& .MuiPickersDay-root": {
            color: "#3f4e8c",
          },
          "& .MuiPickersDay-root.Mui-selected": {
            backgroundColor: "#BFA2CA",
            color: "#3f4e8c",
          },
          "& .MuiPickersYear-root": {
            color: "#3f4e8c",
          },
          "& .MuiYearCalendar-button": {
            color: "#3f4e8c",
          },
          "& .MuiPickersMonth-root": {
            color: "#3f4e8c",
          },
        },
      },
    }}
    {...props}
  />
);
